<div [hidden]="appService.isLoading | async">
  <fieldset>
    <legend>Device scan</legend>

    <!--<app-device-scanner></app-device-scanner>-->

    <ng-container>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="loadFields('patientOnECMO')">Scan equipment (patient currently on ECMO)</button>
      <!--<button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="loadFields('deviceFutureUse')">Scan equipment (dry circuit for future use)</button>-->
      <button [routerLink]="['/patientsanddevices/']" class="form-execute-buttons" type="button" color="primary" mat-raised-button>Patients with scanned devices</button>
    </ng-container>

    <div *ngIf="optionSelected == 1">
      <form autocomplete="off" (submit)="save()" [formGroup]="form">

        <div>
          <div class="control-item">
            <label for="PatientUniqueId" [class.required-field]="form.controls['PatientUniqueId'].hasError('required')">UniqueId:</label>
            <br />
            <mat-form-field appearance="outline" class="control-item">
              <input matInput type="text" maxlength="20" required id="PatientUniqueId" name="PatientUniqueId" formControlName="PatientUniqueId" class="mat-input">
            </mat-form-field>
            <div class="hard-error" *ngIf="form.controls['PatientUniqueId'].hasError('required')">This field is required!</div>
          </div>

          <div class="control-item">
            <label [class.required-field]="form.controls['TimeOn'].hasError('required')">Time on: {{form.controls['TimeOn'].value}}</label>
            <br />
            <elso-datetime-picker [model]="form.get('TimeOn')" id="TimeOn"></elso-datetime-picker>
            <div class="hard-error" *ngIf="form.controls['TimeOn'].hasError('required')">This field is required!</div>
          </div>

          <!--<div class="control-item">
            <label for="RunNo" [class.required-field]="form.controls['RunNo'].hasError('required')">RunNo:</label>
            <br />
            <mat-form-field appearance="outline" class="control-item">
              <input matInput type="number" maxlength="1" required id="RunNo" name="RunNo" formControlName="RunNo" class="mat-input">
            </mat-form-field>
            <div class="hard-error" *ngIf="form.controls['RunNo'].hasError('required')">This field is required!</div>
          </div>-->

          <!--<div class="control-item">
    <label [class.required-field]="form.controls['BirthDate'].hasError('required')">Birthdate: {{form.controls['BirthDate'].value}}</label>
    <br />
    <elso-datetime-picker [model]="form.get('BirthDate')" id="BirthDate"></elso-datetime-picker>
    <div class="hard-error" *ngIf="form.controls['BirthDate'].hasError('required')">This field is required!</div>
  </div>

  <div class="control-item">
    <label [class.required-field]="form.controls['TimeOn'].hasError('required')">Time on: {{form.controls['TimeOn'].value}}</label>
    <br />
    <elso-datetime-picker [model]="form.get('TimeOn')" id="TimeOn"></elso-datetime-picker>
    <div class="hard-error" *ngIf="form.controls['TimeOn'].hasError('required')">This field is required!</div>
  </div>

  <div class="control-item">
    <label [class.required-field]="form.controls['TimeOff'].hasError('required')">Time off: {{form.controls['TimeOff'].value}}</label>
    <br />
    <elso-datetime-picker [model]="form.get('TimeOff')" id="TimeOff"></elso-datetime-picker>
    <div class="hard-error" *ngIf="form.controls['TimeOff'].hasError('required')">This field is required!</div>
  </div>-->
        </div>

        <!--Scan device with device info for examination-->
        <!--<div *ngIf="optionSelected == 2">
          <div class="control-item">
            <label for="DeviceScanSetName" [class.required-field]="form.controls['DeviceScanSetName'].hasError('required')">Equipment group:</label>
            <br />
            <mat-form-field appearance="outline" class="control-item">
              <input matInput type="text" maxlength="20" required id="DeviceScanSetName" name="DeviceScanSetName" formControlName="DeviceScanSetName" class="mat-input">
            </mat-form-field>
            <div class="hard-error" *ngIf="form.controls['DeviceScanSetName'].hasError('required')">This field is required!</div>
          </div>
        </div>-->

        <div *ngIf="filteredPatientData != null">
          <div class="control-item">
            <span><b>UniqueId</b>: {{filteredPatientData.UniqueId}}</span>
          </div>
          <div class="control-item">
            <span><b>Admit date</b>: {{filteredPatientData.AdmitDate | dateFormat}}</span>
          </div>
          <div class="control-item">
            <span><b>RunNo</b>: {{filteredPatientData.RunNo}}</span>
          </div>
          <div class="control-item">
            <span><b>Birthdate</b>: {{filteredPatientData.Birthdate | dateFormat}}</span>
          </div>
          <div class="control-item">
            <span><b>Time on</b>: {{filteredPatientData.TimeOn | dateFormat}}</span>
          </div>
          <div class="control-item">
            <span><b>Time off</b>: {{filteredPatientData.TimeOff | dateFormat}}</span>
          </div>
          <div class="control-item">
            <span><b>Sex</b>: {{appService.getEnumName(filteredPatientData.Sex, enumService.enumSex)}}</span>
          </div>

          <div>
            <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="openScanner()">Proceed to scan</button>
          </div>
        </div>
      </form>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="findPatient()" [disabled]="form.invalid">Find patient</button>
    </div>
  </fieldset>
  <button [routerLink]="['/home']" class="form-execute-buttons" type="button" color="primary" mat-raised-button>Back</button>
</div>
